export default __webpack_public_path__ + "static/media/Rafal.0b1000c7.jpeg";